import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";

export interface Themes {
  [key: string]: Record<string, string>;
}

export type Theme = Record<string, string>;

export interface SetCssVarsProps {
  appearance: Appearance;
  document?: Document;
  themes: Themes;
}

export const setCssVars = ({
  themes,
  appearance,
  document = window.document,
}: SetCssVarsProps) => {
  if (!document) return;

  const root = document.documentElement;

  const appearanceVars = themes[appearance];
  for (const [key, value] of Object.entries(appearanceVars)) {
    root.style.setProperty(`--${key}`, value);
  }

  for (const themeKey of Object.keys(themes)) {
    if (themeKey === "light" || themeKey === "dark") continue;

    const extraVars = themes[themeKey];
    for (const [cssVarKey, cssVarValue] of Object.entries(extraVars)) {
      root.style.setProperty(`--${cssVarKey}`, cssVarValue);
    }
  }
};
